const englishNumbers = {
    '۰': '0',
    '۱': '1',
    '۲': '2',
    '۳': '3',
    '۴': '4',
    '۵': '5',
    '۶': '6',
    '۷': '7',
    '۸': '8',
    '۹': '9'
};

const persianNumbers = {
    '0': '۰',
    '1': '۱',
    '2': '۲',
    '3': '۳',
    '4': '۴',
    '5': '۵',
    '6': '۶',
    '7': '۷',
    '8': '۸',
    '9': '۹'
};

module.exports = {
    deLocalize: (number) => {
        let r = '';
        if (typeof number !== typeof '')
            number = '' + number;
        for (let i = 0; i < number.length; ++i)
            if (englishNumbers.hasOwnProperty(number[i]))
                r += englishNumbers[number[i]];
            else if (persianNumbers.hasOwnProperty(number[i]))
                r += number[i];
            else
                r += number[i];
        return r;
    },
    Localize: (number) => {
        let r = '';
        if (typeof number !== typeof '')
            number = '' + number;
        for (let i = 0; i < number.length; ++i)
            if (persianNumbers.hasOwnProperty(number[i]))
                r += persianNumbers[number[i]];
            else if (englishNumbers.hasOwnProperty(number[i]))
                r += number[i];
            else
                r += number[i];
        return r;
    }
};



// WEBPACK FOOTER //
// ./src/js/utils/NumberConvertor.js